import { CUSTOMER_MESSAGES } from '../../../../constants/customerMessages'

export const NEW_REZ_PHONE_NUMBER = '(855) 923-1054'
export const NEW_REZ_DTC_CUSTOMER_PROFILE_ID = 'f2190c10-8853-4d93-8b31-2fb0fe4eda5d'
export const NEW_REZ_UPDATED_DM_NOTIFICATION_TOPIC_KEYS = [
  CUSTOMER_MESSAGES.HOMEOWNER_MARKET.topicKey,
  CUSTOMER_MESSAGES.SHOULD_SELL_MARKET.topicKey,
  CUSTOMER_MESSAGES.HOME_APPRECIATION.topicKey,
  CUSTOMER_MESSAGES.IF_THEY_SHOULD_SELL.topicKey,
  CUSTOMER_MESSAGES.USING_EQUITY.topicKey,
  CUSTOMER_MESSAGES.PURCHASING_POWER.topicKey,
  CUSTOMER_MESSAGES.HOME_VALUE.topicKey
]

export const NEW_REZ_RETAIL_CORP_ID = 'f6730666-cd94-4e1a-b300-de1e370ba15d' // Newrez Retail, contains 151 customers profiles

export const NEW_REZ_SERVICING_CORP_ID = 'b218da63-55bb-4612-a645-ae74b3ac81fa' // Newrez DTC/Servicing, Homebot Partners (Homebot@newrez.com), 1 customers and 1.26m clients

export const NEWREZ_COMPANY_IDS = [
  NEW_REZ_RETAIL_CORP_ID,
  NEW_REZ_SERVICING_CORP_ID,
  'c3a563a1-6aa4-4dea-acff-a7e6cc51a99c', // Newrez API Test, currently no customers/clients
  '9b011f3a-c654-4df5-a139-055d10b214d3' // Newrez API Test 2, 9 clients
]
